<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span>{{ snackbar_msg }}</span>

            <v-btn dark text @click="snackbar = false">
                Close
            </v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-data-table :headers="headers" :items="selection_type_list" class="elevation-1 mytable" dense
                :search="search">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>
                            Selection Type Master
                        </v-toolbar-title>

                        <v-divider class="mx-4" inset vertical />

                        <v-spacer />
                    </v-toolbar>

                    <v-row dense align="center" class="px-2 py-2">
                          <v-col cols="12" sm="3" md="3" class="d-flex align-center ml-2 mt-2 mb-2">
                            <v-btn rounded color="success" outlined :loading="loader" @click="downloadFile">
                                <v-icon left color="success">mdi-export</v-icon>
                                Export
                            </v-btn>
                        </v-col>

                        <v-col class="mr-8" sm="6" md="5" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                hide-details />
                        </v-col>

                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" small v-on="on">
                                    Add Selection Type
                                </v-btn>
                            </template>


                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">
                                            {{ formTitle }}
                                        </span>
                                    </v-card-title>

                                    <v-card-text class="pb-2 pt-3">
                                        <v-row dense>
                                            <v-col cols="12">
                                                <v-icon color="error" small>*</v-icon>
                                                <v-text-field label="Enter Name" v-model="name" outlined dense>
                                                </v-text-field>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-checkbox label="Is Default" v-model="isdefault" dense hide-details
                                                    color="success" class="mt-2 pt-0" />
                                            </v-col>

                                            <v-col cols="12" v-if="editedIndex > -1">
                                                <v-checkbox label="Is Active" v-model="isactive" dense hide-details
                                                    color="success" class="mt-2 pt-0" />
                                            </v-col>
                                        </v-row>
                                    </v-card-text>

                                    <v-card-actions class="justify-center pt-0 pb-3">
                                        <v-btn class="button" @click="close">
                                            Cancel
                                        </v-btn>

                                        <v-btn color="primary" class="button" @click="save">
                                            {{ editedIndex === -1 ? "Save" : "Update" }}
                                        </v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>

               <template v-slot:item.isdefault="{ item }">
                    <v-icon
                        :color="item.isdefault ? 'success' : 'error'"
                    >
                        {{ item.isdefault ? 'mdi-check-circle' : 'mdi-close-circle' }}
                    </v-icon>
                </template>

                <template v-slot:item.isactive="{ item }">
                    <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
                        @change="toggle(item)" hide-details class="mt-0" />
                </template>

                <template v-slot:item.action="{ item }">
                    <div class="d-flex align-center">
                        <v-avatar size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon" @click="editItem(item)">
                                edit
                            </v-icon>
                        </v-avatar>

                        <v-avatar size="25" class="delete-avatar ml-2">
                            <v-icon class="delete-v-icon" @click="deleteItem(item)">
                                mdi-delete
                            </v-icon>
                        </v-avatar>
                    </div>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
export default {
    data: () => ({
        valid: false,

        snackbar: false,
        snackbar_msg: "",
        color: "",

        search: "",
        dialog: false,

        name: "",
        isactive: true,
        isdefault: false,

        editedIndex: -1,

        selection_type_list: [],

        headers: [
            {
                text: "Sr No",
                value: "srno",
                sortable: false
            },
            {
                text: "Name",
                value: "name",
                sortable: false
            },
            {
                text: "Default",
                value: "isdefault",
                sortable: false
            },
            {
                text: "Active",
                value: "isactive",
                sortable: false
            },
            {
                text: "Actions",
                value: "action",
                sortable: false
            }
        ],

        editedItem: {
            id: "",
            name: "",
            isactive: true,
            isdefault: false
        },

        defaultItem: {
            id: "",
            name: "",
            isactive: true,
            isdefault: false
        }
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1
                ? "Add Selection Type"
                : "Edit Selection Type";
        }
    },

    mounted() {
        this.onLoad();
    },

    methods: {
        onLoad() {
            axios
                .post("/admission/getSelectionTypeLists")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.selection_type_list =
                            res.data.selection_type_list.map((item, index) => ({
                                ...item,
                                srno: index + 1
                            }));
                    }
                });
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        close() {
            this.dialog = false;
            this.name = "";
            this.isactive = true;
            this.isdefault = false;

            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        editItem(item) {
            this.editedIndex =
                this.selection_type_list.indexOf(item);

            this.editedItem = {
                id: item.id,
                name: item.name,
                isactive: item.isactive,
                isdefault: item.isdefault
            };

            this.name = item.name;
            this.isactive = item.isactive;
            this.isdefault = item.isdefault;

            this.dialog = true;
        },

        isValidated() {
            if (!this.name) {
                this.showSnackbar("#b71c1c", "Enter Selection Type Name...");
                return false;
            }
            return true;
        },

        save() {
            if (!this.isValidated()) {
                return;
            }

            if (this.editedIndex > -1) {
                this.editedItem.name = this.name;
                this.editedItem.isactive = this.isactive;
                this.editedItem.isdefault = this.isdefault;

                axios
                    .post("/admission/editSelectionType", this.editedItem)
                    .then((res) => {
                        if (res.data.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Updated Successfully...");

                            this.close();
                            this.onLoad();
                        } else {
                            this.showSnackbar("#b71c1c", res.data.msg);
                        }
                    });

            } else {
                const payload = {
                    name: this.name,
                    isdefault: this.isdefault
                };
                axios
                    .post(
                        "/admission/saveSelectionType",
                        payload
                    )
                    .then((res) => {
                        if (res.data.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Saved Successfully...");
                            this.close();
                            this.onLoad();
                        } else {
                            this.showSnackbar("#b71c1c", res.data.msg);
                        }
                    });
            }
        },

        toggle(item) {
            axios
                .post("/admission/toggleSelectionType", {
                    id: item.id,
                    toggle: item.isactive
                })
                .then((res) => {
                    if (res.data.code == "SUCCESS") {
                        this.showSnackbar("#4caf50", "Updated Successfully...");
                    }
                });
        },

        deleteItem(item) {
            if (confirm("Are you sure you want to delete?")) {
                axios
                    .post("/admission/deleteSelectionType",
                        {
                            id: item.id
                        }
                    )
                    .then((res) => {
                        if (res.data.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Deleted Successfully...");
                            this.onLoad();
                        }
                    });
            }
        },

         downloadFile() {
            this.loader = true;

            const excelData = this.selection_type_list.map((item, index) => ({
                "S.No": index + 1,
                "Name": item.name,
                "Is Default": item.isdefault ? "Yes" : "No",
                "Is Active": item.isactive ? "Yes" : "No"
            }));

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Selection Type");
            XLSX.writeFile(workbook, "SelectionType.xlsx");
            this.loader = false;
        },

    }
};
</script>

<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}

.mytable /deep/ thead th {
    background: #0f2027;
    background: -webkit-linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);

    background: linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);

    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.mytable /deep/ tbody tr td {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
}
</style>